import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
export function App() {
  return <LanguageProvider data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<HomePage data-id="element-3" />} data-id="element-2" />
        <Route path="/ar" element={<HomePage data-id="element-5" />} data-id="element-4" />
        <Route path="/about" element={<AboutPage data-id="element-7" />} data-id="element-6" />
        <Route path="/ar/about" element={<AboutPage data-id="element-9" />} data-id="element-8" />
        <Route path="*" element={<Navigate to="/" replace data-id="element-11" />} data-id="element-10" />
      </Routes>
    </LanguageProvider>;
}